export default {"src":"/_next/static/media/kundli.e8b3fba1.svg","height":43,"width":46,"blurWidth":0,"blurHeight":0};